export const CIRCLE = [
	{
		level: 0,
		repLevel: "empty",
		repCode: "circle-empty",
		backColorCode: "",
		foreColorCode: "",
		value: "AM",
		icon: "AM",
		name: "Level 0",
		desc: "0",
	},
	{
		level: 1,
		repLevel: "quarter",
		repCode: "circle-quarter",
		backColorCode: "DCEDC8",
		foreColorCode: "",
		value: "4D",
		icon: "4D",
		name: "Level 1",
		desc: "1",
	},
	{
		level: 2,
		repLevel: "half",
		repCode: "circle-half",
		backColorCode: "FECDD2",
		foreColorCode: "",
		value: "5H",
		icon: "5H",
		name: "Level 2",
		desc: "2",
	},
	{
		level: 3,
		repLevel: "three-quarter",
		repCode: "circle-three-quarter",
		backColorCode: "EEEEEE",
		foreColorCode: "",
		value: "44",
		icon: "44",
		name: "Level 3",
		desc: "3",
	},
	{
		level: 4,
		repLevel: "full",
		repCode: "circle-full",
		backColorCode: "",
		foreColorCode: "",
		value: "",
		icon: "",
		name: "",
		desc: "",
	},
];
